import {
  GET_USER_DATA,
    SET_ACTIVE,
} from './types';
import firebase from 'firebase';
export function getUserData(id){
  var result = "";
  var data = null;
  return firebase.database().ref('users/' + id + "/").once('value').then(function(snapshot) {
     data = snapshot.val();
   }).then(function(res) {
     return {
       type: GET_USER_DATA,
       payload: {uid: id, data: data},
       }
       });
   };

export function updateUserData(uid,data) {
    return {
      type: GET_USER_DATA,
      payload: {uid: uid, data: data},
    };
}

export function setActive(strat, stratId){
    return {
        type: SET_ACTIVE,
        payload: {strat: strat, stratId: stratId},
    };
}

export function updateStrat(userId, stratId, stratDetails) {

  var postKey;
  var today = new Date();
  if (stratId == null)
  {
   stratDetails.createDateTime = today;
    // Get a key for a new Post.
   postKey = firebase.database().ref().child('users').push().key;
  }
  else {
    stratDetails.lastUpdateDateTime = today;
    postKey = stratId;
  }
  // Write the new post's data simultaneously in the posts list and the user's post list.
  var updates = {};
  updates['users/' + userId + '/strats/' + postKey] = stratDetails;
  firebase.database().ref().update(updates);
    return getUserData(userId);
};


export function deleteStrat(userId, stratId) {
firebase.database().ref('users/' + userId + "/strats").child(stratId).remove().then(function(res) {

   });
  return getUserData(userId);
 };



// WEBPACK FOOTER //
// ./src/app/actions/ts_userData_actions.js